<template>
  <el-dialog
    title="申请评分"
    :visible.sync="shwoApplicationDialog"
    append-to-body
    :close-on-click-modal="false"
    width="800px"
    z-index="1000"
    @close="closeDialog"
  >
    <div class="application-dialog" style="height: auto">
      <div class="application-dialog-tip">
        <div class="tip-item">
          <span class="tip-label">指标名称：</span>
          <span class="tip-content">{{ indexObj.indexName }}</span>
        </div>
        <div class="tip-item">
          <span class="tip-label">指标说明：</span>
          <span class="tip-content">
            {{ indexObj.indexDesc }}
          </span>
        </div>
        <div class="tip-item">
          <span class="tip-label">关联数据标准：</span>
          <span class="tip-content"
            >{{ indexObj.standardDataName }}({{
              indexObj.standardDataCode
            }})</span
          >
        </div>
        <div
          class="tip-item"
          style="margin-top: 20px; margin-bottom: 10px; line-height: 32px"
        >
          <span class="tip-label">积分说明：</span>
          <span class="tip-content">
            在应用中的哪个模块，怎么操作能够产生积分对应上报数据。
          </span>
          <el-button type="primary" size="small" @click="add">添加</el-button>
        </div>
      </div>
      <div class="application-dialog-table">
        <el-table
          :class="applicationDialogTable.length == 0 ? 'emptyTable' : ''"
          :data="applicationDialogTable"
          style="width: 100%"
          v-loading="loading"
          height="300"
        >
          <el-table-column>
            <template slot="header" slot-scope="scope">
              <div class="table-header-text">模块名称<span>*</span></div>
            </template>
            <template slot-scope="{ row, $index }">
              <el-input
                v-if="row.isUpdate"
                maxlength="50"
                v-model="row.appModule"
              ></el-input>
              <span v-if="!row.isUpdate">{{ row.appModule }}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header" slot-scope="scope">
              <div class="table-header-text">操作说明<span>*</span></div>
            </template>
            <template slot-scope="{ row, $index }">
              <el-input
                v-if="row.isUpdate"
                maxlength="200"
                v-model="row.operateIntro"
              ></el-input>
              <span v-if="!row.isUpdate">{{ row.operateIntro }}</span>
            </template>
          </el-table-column>
          <el-table-column label="帮助链接">
            <template slot-scope="{ row, $index }">
              <el-input
                v-if="row.isUpdate"
                maxlength="200"
                v-model="row.helpUrl"
              ></el-input>
              <span v-if="!row.isUpdate">
                <a v-if="row.helpUrl" :href="row.helpUrl" target="_blank" class="link_text">查看帮助</a>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="save(scope.row)"
                v-if="scope.row.isUpdate"
                >保存</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="cancel(scope.row)"
                v-if="scope.row.isUpdate"
                >取消</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="deleteScore(scope.row)"
                v-if="
                  !scope.row.isUpdate
                "
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="dialog-footer" v-if="type === 'add'">
        <el-button type="primary" @click="confirm" :disabled="isFinish">确 定</el-button>
        <el-button @click="closeDialog">取 消</el-button>
      </div>
      <div class="dialog-footer" v-else>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {
  listOperateIntro,
  addOperateIntro,
  updateOperateIntro,
  deleteOperateIntro,
  submitApplyIndex,
} from "@/views/index/api/personalCenter/api.personalCenter.js";
export default {
  data() {
    return {
      applicationDialogTable: [],
      isFinish:false,
      loading:false,
    };
  },
  props: {
    shwoApplicationDialog: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "add",
    },
    editId: {
      type: Number,
      default: null,
    },
    indexObj: {
      type: Object,
      default: {},
    },
  },
  watch: {
    shwoApplicationDialog(n, o) {
      if (n) {
        this.getData();
      }
    },
  },
  methods: {
    // 应用评分操作说明列表查询接口
    getData() {
      this.loading = true;
      listOperateIntro({
        appId: this.$route.query.appId,
        indexId: this.editId,
      }).then((res) => {
        if (res && res.result) {
          this.applicationDialogTable = res.result;
        }
        this.loading=false;
      });
    },
    // 删除
    deleteScore(v) {
      if(this.applicationDialogTable.filter((el) => !el.isUpdate).length === 1){
        return this.$message.warning("只有一个积分说明时无法删除")
      }
      this.$confirm(`确定要删除该条数据吗？`, "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteOperateIntro(v.id).then((res) => {
            if (res && res.code === "00000") {
              this.$message.success("删除成功");
              this.getData();
            }
          });
        })
        .catch(() => {});
    },
    add() {
      if (this.applicationDialogTable.filter((el) => el.isUpdate).length > 0) {
        return this.$message.warning("请先保存内容再添加");
      }
      this.applicationDialogTable.unshift({
        appModule: "",
        operateIntro: "",
        helpUrl: "",
        isUpdate: true,
      });
    },
    save(v) {
      if (v.appModule == "") {
        this.$message({
          message: "模块名称不能为空",
          type: "warning",
        });
        return;
      }
      if (v.operateIntro == "") {
        this.$message({
          message: "操作说明不能为空",
          type: "warning",
        });
        return;
      }
      if(v.helpUrl!==""&&v.helpUrl.indexOf("https://")===-1){
        return this.$message.warning("请输入正确的帮助链接")
      }
      let params = {
        appid: this.$route.query.appId,
        indexId: this.editId,
        appModule: v.appModule,
        operateIntro: v.operateIntro,
        helpUrl: v.helpUrl,
      };
      // 新增
      addOperateIntro(params).then((res) => {
        if (res && res.code === "00000") {
          this.$message.success("保存成功");
          v.isUpdate = false;
          this.getData();
        }
      });
    },
    cancel(v) {
      this.getData();
    },
    closeDialog(v) {
      this.$emit("closeDialog", v);
    },
    confirm() {
      if (
        this.applicationDialogTable.filter((el) => !el.isUpdate).length === 0
      ) {
        return this.$message.warning("请先添加积分说明");
      }
      this.isFinish=true;
      submitApplyIndex({
        appid: this.$route.query.appId,
        indexIdList: [this.editId],
      }).then((res) => {
        if (res && res.code === "00000") {
          this.$message.success("申请成功");
          this.closeDialog("refresh");
        }
        setTimeout(()=>{
            this.isFinish=false;
          },500)
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.application-dialog {
  .application-dialog-tip {
    .tip-item {
      line-height: 23px;
      .tip-label {
        font-weight: bold;
      }
      /deep/.el-button {
        position: absolute;
        right: 20px;
      }
    }
  }
  .link_text{
    color: #4286f5;
    &:hover{
      text-decoration: underline;
    }
  }
  .table-header-text{
    span{
      margin-left: 5px;
      color: red;
    }
  }
  .dialog-footer {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
